import { render } from "./ShortenView.vue?vue&type=template&id=5dcf3bc4&scoped=true"
import script from "./ShortenView.vue?vue&type=script&lang=js"
export * from "./ShortenView.vue?vue&type=script&lang=js"

import "./ShortenView.vue?vue&type=style&index=0&id=5dcf3bc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcf3bc4"]])

export default __exports__